import astrovajra from "../assets/projects/astrovajra.png";
import bharatrescue from "../assets/projects/bharatrescue.png";
import dtuhostel from "../assets/projects/dtuhostel.png";
import esp32home from "../assets/projects/esp32home.png";
import exceltoppt from "../assets/projects/exceltoppt.png";
import facedit from "../assets/projects/facedit.png";
import facemask from "../assets/projects/facemask.png";
import fanfinity from "../assets/projects/fanfinity.png";
import gharbar from "../assets/projects/gharbar.png";
import iqac from "../assets/projects/iqac.png";
import portfolio from "../assets/projects/portfolio.png";
import quickreel from "../assets/projects/quickreel.png";
import systemdesignerstudio from "../assets/projects/systemdesignerstudio.png";
import taskifier from "../assets/projects/taskifier.png";
import treeweaver from "../assets/projects/treeweaver.png";

// Projects reframed as LeetCode "problems". Difficulty reflects scope/complexity
// and is easy to tweak. `tags` power the Topics column, filters and detail view.
export const projects = [
  {
    slug: "system-designer-studio",
    title: "System Designer Studio",
    difficulty: "Hard",
    category: "Web / Full-Stack",
    featured: true,
    tags: [
      "React 18",
      "TypeScript",
      "React Flow",
      "Node.js",
      "Express.js",
      "Prisma",
      "PostgreSQL",
      "Docker",
      "Multi-LLM",
    ],
    image: systemdesignerstudio,
    description:
      "A collaborative system-design IDE to model distributed architectures from a 22-component catalog and 6 templates. Integrates 5 LLM providers (OpenAI, Anthropic, Gemini, Ollama + stub) behind one adapter with a 3-tier, AES-256-GCM-encrypted credential resolver, delivering AI design review and one-click auto-fix. A deploy pipeline compiles diagrams to Docker Compose v3.8 and provisions real containers via the Docker Engine API (dockerode) with SSE log streaming; adds 4-tier RBAC and OAuth + rotating JWT.",
  demo: "https://system-designer-studio.vercel.app/",
  demoLabel: "Design your system now",
  },
  {
    slug: "facedit",
    title: "FacedIt",
    difficulty: "Hard",
    category: "ML / Computer Vision",
    tags: ["OpenCV", "Python", "Machine Learning"],
    image: facedit,
    description:
      "A video face-swapping tool based on the inswapper_128.onnx model. Swap faces in any video directly in the cloud. For educational purposes only.",
    github: "https://github.com/rksharma007/FacedIt",
    demo: "https://colab.research.google.com/github/rksharma007/FacedIt/blob/main/video_face_swap.ipynb",
    demoLabel: "Colab",
  },
  {
    slug: "treeweaver",
    title: "TreeWeaver",
    difficulty: "Medium",
    category: "Web / Full-Stack",
    tags: ["Next.js", "Tailwind CSS", "ShadCN UI", "html2canvas"],
    image: treeweaver,
    description:
      "Your digital canvas for creating, customizing, and sharing beautiful (or beautifully chaotic) family histories. If you thought your family tree was complicated, just wait until you build it here!",
    github: "https://github.com/rksharma007/TreeWeaver",
    demo: "https://treeweaver.onrender.com/",
  },
  {
    slug: "fanfinity",
    title: "FanFinity",
    difficulty: "Hard",
    category: "ML / Computer Vision",
    tags: ["Python", "OpenCV", "MobileNet SSD"],
    image: fanfinity,
    description:
      "A multi-matrix fan automation system based on human detection in marked areas. Mark the areas covered by different fans and let the app handle the rest.",
    github: "https://github.com/rksharma007/FanFinity",
  },
  {
    slug: "excel-to-ppt",
    title: "Excel to PPT",
    difficulty: "Medium",
    category: "Tools / Utility",
    tags: ["Flask", "Python", "Matplotlib", "Pandas"],
    image: exceltoppt,
    description:
      "Upload an Excel sheet, get a PPT with tables and charts within seconds. Excellent for visualising online form-response spreadsheets.",
    github: "https://github.com/rksharma007/Excel-to-PPT",
    demo: "https://excel-to-ppt.onrender.com/",
  },
  {
    slug: "bharatrescue",
    title: "BharatRescue",
    difficulty: "Hard",
    category: "Web / Full-Stack",
    tags: ["Node.js", "Express.js", "MongoDB", "Docker", "GitHub Actions", "IPFS / Filebase"],
    image: bharatrescue,
    description:
      "A cloud-native disaster-relief platform (a.k.a. Central Disaster Rescue Portal) exposing 50+ secured REST endpoints across 9 domain modules for relief, rescue and citizen services. Features multi-tenant RBAC with 3 isolated JWT identity domains (Admin / Staff / Citizen), a geospatial nearest-centre engine (MongoDB 2dsphere), IPFS / Filebase decentralized storage and CI/CD via GitHub Actions. Selected among 120+ applicants for Smart India Hackathon 2024.",
    demo: "https://bharatrescue-admin.netlify.app/",
  },
  {
    slug: "astrovajra",
    title: "AstroVajra",
    difficulty: "Hard",
    category: "Web / Game",
    tags: ["MERN", "React Hooks", "GraphQL", "MUI"],
    image: astrovajra,
    description:
      "A space-shooter game inspired by the 1979 Atari classic Asteroids, with multiple difficulty levels and a global leaderboard for competitive play.",
    demo: "https://astrovajra.onrender.com/",
  },
  {
    slug: "quickreel",
    title: "Quickreel",
    difficulty: "Hard",
    category: "Web / AI",
    tags: ["MERN", "Redux", "Framer", "Stripe", "AWS"],
    image: quickreel,
    description:
      "An AI-powered platform for creators to automatically transform podcasts into logical short clips. Create engaging, high-quality clips with one click.",
    demo: "https://quickreel.io/",
  },
  {
    slug: "portfolio",
    title: "Portfolio",
    difficulty: "Easy",
    category: "Web / Frontend",
    tags: ["React", "Bootstrap"],
    image: portfolio,
    description:
      "My portfolio — built with ReactJS, CSS3, Bootstrap and lots of love.",
    github: "https://github.com/rksharma007/portfolio",
    demo: "https://rksharma.in/",
  },
  {
    slug: "gharbar",
    title: "GharBar",
    difficulty: "Medium",
    category: "Web / Full-Stack",
    tags: ["MERN", "Redux", "Razorpay"],
    image: gharbar,
    description:
      "An authenticated, user-friendly hotel & bar booking website built on the MERN stack with Redux for state management and the Razorpay API for payments.",
    demo: "https://gharbar.netlify.app/",
  },
  {
    slug: "dtu-hostels",
    title: "DTU Hostels",
    difficulty: "Medium",
    category: "Web / Full-Stack",
    tags: ["MERN", "Redux", "Razorpay"],
    image: dtuhostel,
    description:
      "An authenticated hostel-management website on the MERN stack with Redux. Students and admins can manage applications, complaints, mess, payments and notices.",
    demo: "https://dtuhostel.netlify.app/",
  },
  {
    slug: "taskifier",
    title: "Taskifier",
    difficulty: "Medium",
    category: "Web / Full-Stack",
    tags: ["MERN", "Redux", "MUI"],
    image: taskifier,
    description:
      "A web-based authenticated task manager on the MERN stack, powered by Redux and deployed with Render and Netlify. Multiple users can log in simultaneously to manage their daily tasks.",
    github: "https://github.com/rksharma007/taskifier-mern-stack",
    demo: "https://taskifier.netlify.app/",
  },
  {
    slug: "esp32-home-automation",
    title: "ESP32 Home Automation",
    difficulty: "Medium",
    category: "IoT / Embedded",
    tags: ["ESP32", "IFTTT", "Webhooks", "Blynk"],
    image: esp32home,
    description:
      "Control appliances wirelessly with custom voice commands from anywhere in the world, using an ESP32 microcontroller, Blynk, Webhooks, IFTTT and a voice assistant.",
    github: "https://github.com/rksharma007/ESP32_Based_Google_Home_Assistant",
  },
  {
    slug: "face-mask-door-lock",
    title: "Face Mask Door Lock",
    difficulty: "Easy",
    category: "ML / Computer Vision",
    tags: ["Python", "OpenCV", "Raspberry Pi", "Machine Learning"],
    image: facemask,
    description:
      "Uses computer vision for face-mask detection to drive an automatic door open/close system, implementable on a Raspberry Pi with a stepper motor.",
    github: "https://github.com/rksharma007/Face_Mask_Detection_Based_Door_Lock",
  },
  {
    slug: "iqac-dtu",
    title: "IQAC DTU",
    difficulty: "Easy",
    category: "Web / Frontend",
    tags: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    image: iqac,
    description:
      "A website built with HTML5, CSS3, JavaScript and Bootstrap for my university's Internal Quality Assurance Cell, using the AOS library for smooth scroll animations.",
    demo: "https://dtuiqacdemo.netlify.app/",
  },
];

// Number the "problems" 1..n for the list view.
export const numberedProjects = projects.map((p, i) => ({ ...p, number: i + 1 }));

export const DIFFICULTY_ORDER = ["Easy", "Medium", "Hard"];

export const difficultyCounts = projects.reduce(
  (acc, p) => {
    acc[p.difficulty] += 1;
    acc.total += 1;
    return acc;
  },
  { Easy: 0, Medium: 0, Hard: 0, total: 0 }
);

export const categories = [...new Set(projects.map((p) => p.category))].sort();

export const allTags = [...new Set(projects.flatMap((p) => p.tags))].sort();

export default projects;
